import { PhaseAction } from "@platform/types/platform.types";
import { ProgramPhaseActionItem } from "./ProgramPhaseActionItem";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";

type Props = {
  action: PhaseAction;
  disabled: boolean;
};

export function ProgramPhaseActionItemContainer({ action, disabled }: Props) {
  const userTimezoneOption = useUserTimezoneOption();

  return (
    <ProgramPhaseActionItem
      action={action}
      disabled={disabled}
      userTimezoneOption={userTimezoneOption}
    />
  );
}

export default ProgramPhaseActionItemContainer;
